import { SectionHeader } from '@/components/layout/section-header';
import { useAppTheme } from '@/providers/theme-provider';
import { LinearGradient } from 'expo-linear-gradient';
import React, { useCallback, useState } from 'react';
import { NativeScrollEvent, NativeSyntheticEvent, ScrollView, View } from 'react-native';

interface HorizontalSectionProps {
  title: string;
  children: React.ReactNode;
  onActionPress?: () => void;
  actionText?: string;
}

export const HorizontalSection = React.memo<HorizontalSectionProps>(({
  title,
  children,
  onActionPress,
  actionText
}) => {
  const theme = useAppTheme();
  const [scrolledFromStart, setScrolledFromStart] = useState(false);
  const [scrolledToEnd, setScrolledToEnd] = useState(false);

  const handleScroll = useCallback((e: NativeSyntheticEvent<NativeScrollEvent>) => {
    const { contentOffset, contentSize, layoutMeasurement } = e.nativeEvent;
    setScrolledFromStart(contentOffset.x > 10);
    setScrolledToEnd(contentOffset.x + layoutMeasurement.width >= contentSize.width - 10);
  }, []);

  return (
    <View className="mb-6">
      <View className="px-4">
        <SectionHeader title={title} onActionPress={onActionPress} actionText={actionText} />
      </View>
      <View style={{ position: 'relative' }}>
        <ScrollView
          horizontal
          showsHorizontalScrollIndicator={false}
          contentContainerStyle={{ paddingHorizontal: 16 }}
          onScroll={handleScroll}
          scrollEventThrottle={16}
        >
          {children}
        </ScrollView>
        {scrolledFromStart && (
          <View
            style={{
              position: 'absolute',
              left: 0,
              top: 0,
              bottom: 0,
              width: 40,
              pointerEvents: 'none',
            }}
          >
            <LinearGradient
              colors={[theme.colors.background, 'transparent']}
              start={{ x: 0, y: 0 }}
              end={{ x: 1, y: 0 }}
              style={{
                position: 'absolute',
                left: 0,
                top: 0,
                bottom: 0,
                width: 40,
              }}
            />
          </View>
        )}
        {!scrolledToEnd && (
          <View
            style={{
              position: 'absolute',
              right: 0,
              top: 0,
              bottom: 0,
              width: 40,
              pointerEvents: 'none',
            }}
          >
            <LinearGradient
              colors={['transparent', theme.colors.background]}
              start={{ x: 0, y: 0 }}
              end={{ x: 1, y: 0 }}
              style={{
                position: 'absolute',
                right: 0,
                top: 0,
                bottom: 0,
                width: 40,
              }}
            />
          </View>
        )}
      </View>
    </View>
  );
});

HorizontalSection.displayName = 'HorizontalSection';
